import store from "../../store";

export default (to, from, next) => {
    if (store.getters['authenticated'] == false){
        next({name:'SignIn'})
    } else {
        next()
    }
}